import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class NotificationAdd extends Component{
	render(){
		const {notifications_types} =this.props;
		let nc = _.find(notifications_types.permissions, (o) => {return o==='Create'});
		return (
			nc ?
				<p>
					<NavLink to={`/notificaciones/crear`} className="button is-small is-inm-purple">{'Agregar notificación'}</NavLink>
				</p>:''
		)
	}
}

export default SecureLayout(NotificationAdd);


// WEBPACK FOOTER //
// ./src/elements/notifications/widget/notification_type_add.jsx